/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_NewsletterInputs */

const en__field_newsletter = /** @type {(inputs: _Field_NewsletterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe newsletter`)
};

const de__field_newsletter = /** @type {(inputs: _Field_NewsletterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Newsletter abonnieren`)
};

/**
* | output |
* | --- |
* | "Subscribe newsletter" |
*
* @param {_Field_NewsletterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_newsletter = /** @type {((inputs?: _Field_NewsletterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_NewsletterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_newsletter(inputs)
	return de__field_newsletter(inputs)
});